import axios from './index';

// Normaliza y estructura los filtros para la API
const normalizeFilters = (filters) => ({
  startDate: filters.StartDate ? new Date(filters.StartDate) : null,
  endDate: filters.EndDate ? new Date(filters.EndDate) : null,
  healthInsurance: filters.HealthInsurance?.trim() || undefined,
  medicalRecordNumber: filters.MedicalRecordNumber?.trim() || undefined,
  practitioner: filters.Practitioner?.trim() || undefined,
  page: filters.pagination?.page || 1,
  sizePerPage: filters.pagination?.sizePerPage || 10,
  sortField: filters.sort?.sortField || undefined,
  sortOrder: filters.sort?.sortOrder || undefined,
});

// Limpia los filtros eliminando claves vacías
const buildQueryParams = (filters) =>
  Object.fromEntries(
    Object.entries(normalizeFilters(filters)).filter(([_, value]) => value !== undefined && value !== "")
  );

// Llamada a la API para obtener reportes de recetas
export const getPrescriptionReports = async (filters) => {
  try {
    const params = buildQueryParams(filters);
    console.log("Params", params)
    const { data } = await axios.get('/api/v1/prescriptionreports', { params });

    return {
      data: data.data,
      totalCount: data.count
    };
  } catch (error) {
    return { data: [], totalCount: 0, error: true, message: error.message };
  }
};

// Exporta a Excel solo los datos filtrados
export const exportToExcel = async (filters) => {
  try {
    const params = buildQueryParams(filters);
      return await axios.get('/api/v1/prescriptionreports/exportToExcel', {
          responseType: 'blob',
          params
      });
  } catch (error) {
    alert("Error al exportar a Excel. Intente nuevamente.");
  }
};
